import ESGReportDownloadTemplate from '../components/ESGReportDownloadTemplate'
import TitleLabel from '.././../entity/components/TitleLabel'
import { entityOaid } from '../../util/util'
export default {
  name: 'ESGEntityReportDownload',
  data () {
    return {
      oaid:''
    }
  },
  components: {
    ESGReportDownloadTemplate, TitleLabel
  },
  created() {
    let id = this.$route.params.oaid
    entityOaid.oaid(id).then(result => {
      this.oaid = result
    })
  }
}


// WEBPACK FOOTER //
// ./src/esg/js/ESGEntityReportDownload.js